let children = []

children.push({
    path: "/contabilidad/facturasxml",
    name: "CNT_INVOICES_XML",
    component: () =>
        import("../views/Accounting/InvoicesXML/InvoicesXML.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Contabilidad", disabled: true },
            {
                text: "Facturas XML",
                href: "/contabilidad/facturasxml",
            },
        ],
    },
});

children.push({
    path: "/contabilidad/Presupuesto",
    name: "BUDGETCNT",
    component: () =>
        import("../views/Accounting/Budget.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Contabilidad", disabled: true },
            {
                text: "Facturas XML",
                href: "/contabilidad/Presupuesto",
            },
        ],
    },
});

children.push({
    path: "/contabilidad/periodoscontables",
    name: "ACCOUNTING_PERIODS",
    component: () =>
        import("../views/Accounting/AccountingPeriods/Periods.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Contabilidad", disabled: true },
            {
                text: "Periodos Contables",
                href: "/contabilidad/periodoscontables",
            },
        ],
    },
});

children.push({
    path: "/contabilidad/presupuesto-agil",
    name: "ACCOUNTING_BUDGETAGILE",
    component: () =>
        import("../views/Accounting/BudgetAgile/BudgetAgile.vue"),
    meta: {
        authenticated: true,
        breadcrumb: [
            { text: "Inicio", href: "/#/" },
            { text: "Contabilidad", disabled: true },
            {
                text: "Presupuesto Ágil",
                href: "/contabilidad/presupuesto-agil",
            },
        ],
    },
});

export { children }